.container {
  background-color: #fff;
  box-shadow: 0 0 2px 2px #e4eaeb;
  padding: var(--space-xl);
  margin: 0 var(--space-s) var(--space-m);

  hr {
    margin-left: calc(-1 * var(--space-xl));
    margin-right: calc(-1 * var(--space-xl));
  }
}
